<template>
  <div :class="[`x3-25`, className || ``]">
    <div class="ellipse-170-4"></div>
    <div class="x1-82 poppins-normal-white-40px">{{ x1 }}</div>
    <img
      class="line-46-4"
      src="https://cdn.animaapp.com/projects/68d55a995799e527ee530c15/releases/68d96a345506c1136576f4d8/img/line-46.svg"
      alt="Line 46"
    />
  </div>
</template>

<script>
export default {
  name: "X382",
  props: ["x1", "className"],
};
</script>

<style>
.x3-25 {
  height: 60px;
  left: 610px;
  position: absolute;
  top: 1px;
  width: 112px;
}

.ellipse-170-4 {
  aspect-ratio: 1;
  background-color: var(--black-7);
  border: 1px solid;
  border-color: var(--black-8);
  border-radius: 30px;
  height: 60px;
  left: 50px;
  position: absolute;
  top: 0;
  width: 60px;
}

.x1-82 {
  left: 69px;
  letter-spacing: 0.8px;
  line-height: normal;
  position: absolute;
  top: 0;
}

.line-46-4 {
  height: 1px;
  left: 0;
  object-fit: cover;
  position: absolute;
  top: 29px;
  width: 50px;
}

.x3-25.x3-26,
.x3-25.x3-28 {
  left: 830px;
}

.x3-25.x3-26 .x1-82,
.x3-25.x2-29 .x1-82,
.x3-25.x2-30 .x1-82,
.x3-25.x3-28 .x1-82,
.x3-25.x2-31 .x1-82,
.x3-25.x2-32 .x1-82 {
  left: 67px;
}

.x3-25.x2-29,
.x3-25.x2-31 {
  left: 720px;
}

.x3-25.x2-30,
.x3-25.x2-32 {
  left: 500px;
}
</style>
